import { useTranslation } from 'react-i18next';
import React, { useContext } from "react";
import { Button, Modal, message } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/erp_subpackage/components/YhBox";
import { useSaleDcModel } from "../seleDcModel";
import { MyContext } from "@/store/myContext"
import { formatNum } from '@/erp_subpackage/utils/util';

export const DataBox = () => {
    const { t } = useTranslation();
    const { selectedRowKeys, statistics, exportSaleDc, exportSDcdetail, rowsDescTotal } = useSaleDcModel();
    const { state, dispatch, detailsPage } = useContext(MyContext)

    const goPageNav = (mode, rowCode) => {
        let tabName = {
            add: t(`sale.view.DataBox.调出单新增`),
            edit: t(`sale.view.DataBox.调出单编辑`),
            look: t(`sale.view.DataBox.调出单查看`),
        }
        let modeKey = "saleDc/" + mode
        //动态传入要删除的nav key
        function handleDispatch(obj = {}) {
            dispatch({
                ...obj,
                type: "changeTabs",
                name: tabName[mode],
                activeMenu: modeKey,
                content: detailsPage.SaleDcDetails({
                    dispatch,
                    modeKey,
                    mode,
                    rowId: rowCode ?? selectedRowKeys[0]?.code
                }),
            })
        }

        if (mode === "edit") {
            const findNav = state.panes.find((item) => item.key === modeKey)
            if (findNav) {
                Modal.confirm({
                    title: `${t(`sale.view.DataBox.温馨提醒`)}！`,
                    content: t(`sale.view.DataBox.您还有调出单详情未保存，是否跳转`),
                    okText: t(`sale.view.DataBox.跳转未保存页`),
                    cancelText: t(`sale.view.DataBox.打开新页签`),
                    onOk: () => {
                        handleDispatch()
                    },
                    //打开新页签重新生成
                    onCancel: () => {
                        handleDispatch({ deleteKey: modeKey })
                    },
                })
                return
            }
            handleDispatch()
        } else if (mode === "add") {
            handleDispatch()
        } else if (mode === "look") {
            handleDispatch({ deleteKey: modeKey })
        }
    }

    const desc = [
        {
            label: t(`sale.view.DataBox.调出数量`),
            value: !selectedRowKeys.length ? statistics?.totalNum : rowsDescTotal.totalNum,
            color: 'green'
        },
        {
            label: t(`sale.view.DataBox.应收金额`),
            value: !selectedRowKeys.length ? `￥${formatNum(statistics?.totalAmount)}` : `￥${formatNum(rowsDescTotal.totalAmount)}`,
            color: 'red'
        },
    ]

    const action = <>
        <Button
            className="btn-item"
            type="link"
            shape="round"
            onClick={() => goPageNav('add')}
        > {t(`sale.view.DataBox.新增`)}</Button>
        <Button
            className="btn-item"
            type="link"
            shape="round"
            onClick={() => {
                if (selectedRowKeys.length !== 1) {
                    message.warning(`${t(`sale.view.DataBox.请选择单条数据进行编辑，点击鼠标右键可一键选中哦`)}！`)
                    return
                }
                goPageNav("edit")
            }}
        > {t(`sale.view.DataBox.编辑`)}</Button>
        <Button
            className="btn-item"
            type="link"
            shape="round"
            onClick={() => exportSaleDc()}
        > {t(`sale.view.DataBox.导出`)}</Button>
    </>;

    return (
        <YhBox title={t(`sale.view.DataBox.调出单列表`)} descriptions={desc} action={action}>
            <DataTable goPageNav={goPageNav} />
        </YhBox>
    )
}